(function () {
  if (window.OTTUNIOffice) {
    window.OTTUNIOffice.init(document);
    return;
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileLayout = window.matchMedia('(max-width: 780px)');

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function initHero(scope) {
    scope.querySelectorAll('[data-oh-hero]:not([data-oh-ready])').forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-oh-hero-slide]'));
      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-oh-hero-step]'));
      var status = root.querySelector('[data-oh-hero-status]');
      var index = 0;
      var pointerStart = null;
      var destroyed = false;

      if (!slides.length) return;
      root.dataset.ohReady = 'true';

      function pauseVideos() {
        slides.forEach(function (slide, slideIndex) {
          var video = slide.querySelector('video');
          if (!video) return;
          if (slideIndex !== index || reduceMotion.matches || (mobileLayout.matches && video.classList.contains('oh-hero__asset--desktop'))) {
            video.pause();
            return;
          }
          video.preload = 'metadata';
          video.play().catch(function () {});
        });
      }

      function setSlide(nextIndex, announce) {
        if (destroyed) return;
        index = (nextIndex + slides.length) % slides.length;
        root.dataset.ohHeroIndex = String(index);

        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.toggleAttribute('inert', !active);
        });

        pauseVideos();

        if (announce && status) {
          status.textContent = slides[index].getAttribute('aria-label') || '';
        }

      }

      steps.forEach(function (button) {
        button.addEventListener('click', function () {
          setSlide(index + Number(button.dataset.ohHeroStep), true);
        });
      });

      root.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' || event.target.closest('a, button')) return;
        pointerStart = event.clientX;
      });

      root.addEventListener('pointerup', function (event) {
        if (pointerStart === null) return;
        var distance = event.clientX - pointerStart;
        pointerStart = null;
        if (Math.abs(distance) < 48) return;
        setSlide(index + (distance < 0 ? 1 : -1), true);
      });

      root.addEventListener('pointercancel', function () {
        pointerStart = null;
      });

      root.addEventListener('shopify:block:select', function (event) {
        var slide = event.target.closest('[data-oh-hero-slide]');
        if (!slide || !root.contains(slide)) return;
        setSlide(Number(slide.dataset.ohHeroIndex), false);
      });

      function onVisibilityChange() {
        if (document.hidden) {
          slides.forEach(function (slide) {
            var video = slide.querySelector('video');
            if (video) video.pause();
          });
        } else {
          pauseVideos();
        }
      }

      function cleanup() {
        if (destroyed) return;
        destroyed = true;
        slides.forEach(function (slide) {
          var video = slide.querySelector('video');
          if (video) video.pause();
        });
        document.removeEventListener('visibilitychange', onVisibilityChange);
        document.removeEventListener('shopify:section:unload', onSectionUnload);
        mobileLayout.removeEventListener('change', pauseVideos);
      }

      function onSectionUnload(event) {
        if (event.target === root || event.target.contains(root)) cleanup();
      }

      document.addEventListener('visibilitychange', onVisibilityChange);
      document.addEventListener('shopify:section:unload', onSectionUnload);
      mobileLayout.addEventListener('change', pauseVideos);

      setSlide(0, false);
    });
  }

  function initSupport(scope) {
    scope.querySelectorAll('[data-oh-support]:not([data-oh-ready])').forEach(function (root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-oh-support-item]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('.oh-support__panel'));
      var modelButtons = Array.prototype.slice.call(root.querySelectorAll('[data-oh-support-model-button]'));
      var modelImages = Array.prototype.slice.call(root.querySelectorAll('.oh-support__chair--082a, .oh-support__chair--097a'));
      var mediaLayers = Array.prototype.slice.call(root.querySelectorAll('[data-oh-support-media]'));
      var eyebrow = root.querySelector('[data-oh-support-eyebrow]');
      var list = root.querySelector('[data-oh-support-list]');
      var visibleItems = items.slice();
      var changeTimer = 0;
      var mediaObserver = null;
      var mediaIsVisible = !('IntersectionObserver' in window);
      var destroyed = false;

      if (!items.length) return;
      root.dataset.ohReady = 'true';

      function pauseSupportVideos() {
        mediaLayers.forEach(function (layer) {
          var video = layer.querySelector('video');
          if (video) video.pause();
        });
      }

      function playActiveSupportVideo() {
        if (destroyed || document.hidden || !mediaIsVisible || reduceMotion.matches) return;
        var activeLayer = mediaLayers.find(function (layer) {
          return layer.classList.contains('is-active');
        });
        if (!activeLayer) return;
        var video = activeLayer.querySelector('video');
        if (!video) return;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.play().catch(function () {});
      }

      function setFeatureMedia(activeTrigger) {
        if (!mediaLayers.length || !activeTrigger) return;
        var mediaId = activeTrigger.dataset.ohSupportMediaId;

        mediaLayers.forEach(function (layer) {
          var active = layer.dataset.ohSupportMediaId === mediaId;
          var wasActive = layer.classList.contains('is-active');
          var video = layer.querySelector('video');

          layer.classList.toggle('is-active', active);
          layer.setAttribute('aria-hidden', active ? 'false' : 'true');

          if (!video) return;
          if (!active) {
            video.pause();
            return;
          }
          if (!wasActive) video.currentTime = 0;
        });

        playActiveSupportVideo();
      }

      function setFeature(index, moveFocus) {
        var visibleTriggers = visibleItems.map(function (item) {
          return item.querySelector('.oh-support__trigger');
        }).filter(Boolean);

        if (!visibleTriggers.length) return;

        var nextIndex = (index + visibleTriggers.length) % visibleTriggers.length;
        var activeItem = visibleItems[nextIndex];
        var activeTrigger = visibleTriggers[nextIndex];
        var activePanelId = activeTrigger.getAttribute('aria-controls');

        items.forEach(function (item) {
          var trigger = item.querySelector('.oh-support__trigger');
          var active = item === activeItem;
          if (!trigger) return;
          trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
          if (active && moveFocus) trigger.focus();
          item.classList.toggle('is-active', active);
        });

        panels.forEach(function (panel) {
          panel.hidden = panel.id !== activePanelId;
        });

        root.style.setProperty('--oh-focus-x', activeTrigger.dataset.focusX + '%');
        root.style.setProperty('--oh-focus-y', activeTrigger.dataset.focusY + '%');
        root.style.setProperty('--oh-focus-scale', activeTrigger.dataset.focusScale);
        setFeatureMedia(activeTrigger);
        root.dataset.ohChanging = 'true';
        window.clearTimeout(changeTimer);
        changeTimer = window.setTimeout(function () {
          root.dataset.ohChanging = 'false';
        }, reduceMotion.matches ? 0 : 720);
      }

      function setModel(model) {
        var hasModelSwitch = modelButtons.length > 0;
        var matchingItems = hasModelSwitch
          ? items.filter(function (item) {
              return item.dataset.ohSupportModel === model;
            })
          : items.slice();

        if (!matchingItems.length) return;

        root.dataset.ohSupportModel = model;
        visibleItems = matchingItems;

        items.forEach(function (item) {
          var visible = visibleItems.indexOf(item) !== -1;
          item.hidden = !visible;
          if (!visible) item.classList.remove('is-active');
        });

        modelButtons.forEach(function (button) {
          button.setAttribute('aria-pressed', button.dataset.ohSupportModelButton === model ? 'true' : 'false');
        });

        modelImages.forEach(function (image) {
          var imageModel = image.classList.contains('oh-support__chair--082a') ? '082a' : '097a';
          image.classList.toggle('is-active', imageModel === model);
        });

        if (eyebrow) {
          var eyebrowText = root.getAttribute('data-oh-support-eyebrow-' + model);
          if (eyebrowText) eyebrow.textContent = eyebrowText;
        }

        if (list) {
          var listLabel = root.getAttribute('data-oh-support-label-' + model);
          if (listLabel) list.setAttribute('aria-label', listLabel);
        }

        setFeature(0, false);
      }

      items.forEach(function (item) {
        var trigger = item.querySelector('.oh-support__trigger');
        if (!trigger) return;

        trigger.addEventListener('click', function () {
          var index = visibleItems.indexOf(item);
          if (index < 0) return;
          setFeature(index, false);
        });

        trigger.addEventListener('keydown', function (event) {
          var index = visibleItems.indexOf(item);
          if (index < 0) return;
          var next = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = index + 1;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = index - 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = visibleItems.length - 1;
          if (next === index) return;
          event.preventDefault();
          setFeature(next, true);
        });
      });

      root.querySelectorAll('[data-oh-support-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          var current = visibleItems.findIndex(function (item) {
            var trigger = item.querySelector('.oh-support__trigger');
            return trigger && trigger.getAttribute('aria-expanded') === 'true';
          });
          setFeature(current + Number(button.dataset.ohSupportStep), false);
        });
      });

      modelButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          setModel(button.dataset.ohSupportModelButton);
        });
      });

      function onSupportVisibilityChange() {
        if (document.hidden) pauseSupportVideos();
        else playActiveSupportVideo();
      }

      function cleanupSupport() {
        if (destroyed) return;
        destroyed = true;
        window.clearTimeout(changeTimer);
        pauseSupportVideos();
        if (mediaObserver) mediaObserver.disconnect();
        document.removeEventListener('visibilitychange', onSupportVisibilityChange);
        document.removeEventListener('shopify:section:unload', onSupportSectionUnload);
      }

      function onSupportSectionUnload(event) {
        if (event.target === root || event.target.contains(root)) cleanupSupport();
      }

      if ('IntersectionObserver' in window && mediaLayers.length) {
        mediaObserver = new IntersectionObserver(function (entries) {
          mediaIsVisible = entries.some(function (entry) {
            return entry.isIntersecting && entry.intersectionRatio >= 0.12;
          });
          if (mediaIsVisible) playActiveSupportVideo();
          else pauseSupportVideos();
        }, { threshold: [0, 0.12, 0.5] });
        mediaObserver.observe(root);
      }

      document.addEventListener('visibilitychange', onSupportVisibilityChange);
      document.addEventListener('shopify:section:unload', onSupportSectionUnload);

      setModel(root.dataset.ohSupportModel || '097a');
    });
  }

  function initMaterials(scope) {
    scope.querySelectorAll('[data-oh-materials]:not([data-oh-ready])').forEach(function (root) {
      var track = root.querySelector('[data-oh-material-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-oh-material-slide]'));
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-oh-material-tab]'));
      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-oh-material-step]'));
      var index = 0;

      if (!track || !slides.length) return;
      root.dataset.ohReady = 'true';

      function setMaterial(nextIndex, moveFocus, shouldScroll) {
        index = Math.max(0, Math.min(slides.length - 1, nextIndex));

        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        tabs.forEach(function (tab, tabIndex) {
          var active = tabIndex === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active && moveFocus) tab.focus();
        });

        steps.forEach(function (step) {
          var direction = Number(step.dataset.ohMaterialStep);
          step.disabled = direction < 0 ? index === 0 : index === slides.length - 1;
        });

        if (shouldScroll) {
          track.scrollTo({
            left: slides[index].offsetLeft,
            behavior: reduceMotion.matches ? 'auto' : 'smooth'
          });
        }
      }

      tabs.forEach(function (tab, tabIndex) {
        tab.addEventListener('click', function () {
          setMaterial(tabIndex, false, true);
        });

        tab.addEventListener('keydown', function (event) {
          var next = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = index + 1;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = index - 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = slides.length - 1;
          if (next === index) return;
          event.preventDefault();
          setMaterial(next, true, true);
        });
      });

      steps.forEach(function (step) {
        step.addEventListener('click', function () {
          setMaterial(index + Number(step.dataset.ohMaterialStep), false, true);
        });
      });

      root.addEventListener('keydown', function (event) {
        if (event.target.closest('[data-oh-material-tab]')) return;
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          setMaterial(index + 1, false, true);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          setMaterial(index - 1, false, true);
        }
      });

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.58) {
                setMaterial(Number(entry.target.dataset.ohMaterialSlide), false, false);
              }
            });
          },
          { root: track, threshold: [0.58, 0.72] }
        );
        slides.forEach(function (slide) {
          observer.observe(slide);
        });
      }

      setMaterial(0, false, false);
    });
  }

  function initVideos(scope) {
    scope.querySelectorAll('[data-oh-video]:not([data-oh-ready])').forEach(function (root) {
      var video = root.querySelector('video');
      var button = root.querySelector('[data-oh-video-toggle]');
      var label = root.querySelector('[data-oh-video-label]');

      if (!video || !button || !label) return;
      root.dataset.ohReady = 'true';
      var shouldAutoplay = root.dataset.ohAutoplay === 'true' && !reduceMotion.matches;
      var userPaused = false;

      function sync() {
        var paused = video.paused;
        button.setAttribute('aria-pressed', paused ? 'false' : 'true');
        label.textContent = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      }

      button.addEventListener('click', function () {
        if (video.paused) {
          userPaused = false;
          video.play().catch(function () {});
        } else {
          userPaused = true;
          video.pause();
        }
        sync();
      });

      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);

      video.pause();

      if (shouldAutoplay && 'IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
                if (!userPaused) video.play().catch(function () {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: [0, 0.35] }
        ).observe(root);
      }

      sync();
    });
  }

  function initStories(scope) {
    scope.querySelectorAll('[data-oh-stories]:not([data-oh-ready])').forEach(function (root) {
      var track = root.querySelector('[data-oh-story-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-oh-story-slide]'));
      var count = root.querySelector('[data-oh-story-count]');
      var controls = root.querySelector('.oh-stories__controls');
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-oh-story-step]'));
      var frame = null;
      var dragPointerId = null;
      var dragStartX = 0;
      var dragStartScroll = 0;
      var hasDragged = false;

      if (!track || !slides.length) return;
      root.dataset.ohReady = 'true';

      function getVisibleRange() {
        var left = track.scrollLeft;
        var right = left + track.clientWidth;
        var visible = [];

        slides.forEach(function (slide, slideIndex) {
          var center = slide.offsetLeft + slide.offsetWidth / 2;
          if (center >= left && center <= right) visible.push(slideIndex);
        });

        if (!visible.length) {
          var nearest = slides.reduce(function (best, slide, slideIndex) {
            return Math.abs(slide.offsetLeft - left) < Math.abs(slides[best].offsetLeft - left)
              ? slideIndex
              : best;
          }, 0);
          visible.push(nearest);
        }

        return {
          first: visible[0],
          last: visible[visible.length - 1]
        };
      }

      function sync() {
        frame = null;
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        var hasOverflow = maxScroll > 2;
        var range = getVisibleRange();

        root.classList.toggle('has-overflow', hasOverflow);
        if (controls) controls.hidden = !hasOverflow;
        if (buttons[0]) buttons[0].disabled = !hasOverflow || track.scrollLeft <= 2;
        if (buttons[1]) buttons[1].disabled = !hasOverflow || track.scrollLeft >= maxScroll - 2;

        if (!count) return;
        if (slides.length === 1) {
          count.textContent = '01';
        } else if (range.first === range.last) {
          count.textContent = pad(range.first + 1) + ' / ' + pad(slides.length);
        } else {
          count.textContent =
            pad(range.first + 1) +
            ' — ' +
            pad(range.last + 1) +
            (range.last - range.first + 1 < slides.length ? ' / ' + pad(slides.length) : '');
        }
      }

      function requestSync() {
        if (frame !== null) return;
        frame = window.requestAnimationFrame(sync);
      }

      function move(direction) {
        var range = getVisibleRange();
        var current = direction > 0 ? range.first + 1 : range.first - 1;
        var next = Math.max(0, Math.min(slides.length - 1, current));
        track.scrollTo({
          left: slides[next].offsetLeft,
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      }

      function snapToNearest() {
        var nearest = slides.reduce(function (best, slide, slideIndex) {
          return Math.abs(slide.offsetLeft - track.scrollLeft) <
            Math.abs(slides[best].offsetLeft - track.scrollLeft)
            ? slideIndex
            : best;
        }, 0);

        track.scrollTo({
          left: slides[nearest].offsetLeft,
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      }

      function finishDrag(event) {
        if (dragPointerId === null || event.pointerId !== dragPointerId) return;
        if (track.hasPointerCapture(dragPointerId)) track.releasePointerCapture(dragPointerId);
        dragPointerId = null;
        track.classList.remove('is-dragging');
        if (hasDragged) snapToNearest();
        hasDragged = false;
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          move(Number(button.dataset.ohStoryStep));
        });
      });

      track.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragPointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartScroll = track.scrollLeft;
        hasDragged = false;
        track.setPointerCapture(dragPointerId);
      });

      track.addEventListener('pointermove', function (event) {
        if (dragPointerId === null || event.pointerId !== dragPointerId) return;
        var distance = event.clientX - dragStartX;
        if (!hasDragged && Math.abs(distance) < 5) return;
        hasDragged = true;
        track.classList.add('is-dragging');
        track.scrollLeft = dragStartScroll - distance;
      });

      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);
      track.addEventListener('lostpointercapture', function () {
        dragPointerId = null;
        track.classList.remove('is-dragging');
        if (hasDragged) snapToNearest();
        hasDragged = false;
      });

      track.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });

      track.addEventListener('scroll', requestSync, { passive: true });

      if ('ResizeObserver' in window) {
        new ResizeObserver(requestSync).observe(track);
      } else {
        window.addEventListener('resize', requestSync);
      }

      sync();
    });
  }

  function init(scope) {
    initHero(scope);
    initSupport(scope);
    initMaterials(scope);
    initVideos(scope);
    initStories(scope);
  }

  window.OTTUNIOffice = { init: init };
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  init(document);
})();
